import { Card, Grid, Skeleton, Stack, Typography, styled } from '@mui/material'
import { useRouter } from 'next/router'

const CardStyled = styled(Card)(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.neutralLight[100],
  },
}))

export enum Levels {
  NORMAL = 'normal',
  WARNING = 'warning',
  ALERT = 'alert',
}

interface StatisticCardProps {
  title: string
  count: number
  level: Levels
  onClick: () => void
  loading: boolean
}

const getTextColorFromLevel = (level: Levels) => {
  if (level === Levels.ALERT) return 'red'
  if (level === Levels.WARNING) return '#FF9800' // orange

  return 'neturalDark.900'
}

const StatisticCard = ({ title, count, level, onClick, loading }: StatisticCardProps) => {
  return (
    <CardStyled sx={{ width: '100%' }} onClick={onClick}>
      <Stack sx={{ py: { xs: 3, md: 4 }, px: { xs: 4, md: 5 } }} spacing={1}>
        <Typography variant="HeaderSubtitleMediumMedium" color="text.secondary">
          {!loading ? title : <Skeleton sx={{ width: { xs: 80, md: 150 } }} />}
        </Typography>
        <Typography variant="Body18pxMedium" color={getTextColorFromLevel(level)}>
          {!loading ? count : <Skeleton sx={{ width: { xs: 50, md: 80 } }} />}
        </Typography>
      </Stack>
    </CardStyled>
  )
}

interface SummaryItems {
  title: string
  count: number
  level: Levels
  url: string
  hiddenOnMobile?: boolean
}

interface SummaryProps {
  summaryItems: SummaryItems[]
  loading: boolean
}

function DashboardSummary({ summaryItems, loading }: SummaryProps) {
  const { push } = useRouter()

  return (
    <Stack gap={4} sx={{ width: '100%' }}>
      <Grid container spacing={{ xs: 3, md: 4 }}>
        {summaryItems.map((summaryItem, i) => (
          <Grid
            key={i}
            size={{
              xs: 6,
              md: 4,
            }}
            display={summaryItem.hiddenOnMobile ? { xs: 'none', md: 'block' } : 'block'}
          >
            <StatisticCard onClick={() => push(summaryItem.url)} loading={loading} {...summaryItem} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
}

export { DashboardSummary }
